"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contains = void 0;

var _curry = require("../curry/curry");

var _contains = function _contains(search, source) {
  if (search.length > source.length) {
    return false;
  }

  return source.indexOf(search) !== -1;
};
/**
 * Test if string contains substring
 *
 * @param {string} search Search string
 * @param {string} source Source string
 *
 * @return {boolean}
 *
 * @tag String
 * @signature (search: string, source: string): boolean
 *
 * @example
 * contains("ipsum")("lorem ipsum")
 * // => true
 */


var contains = (0, _curry.curry)(_contains);
exports.contains = contains;